function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import React from 'react';
import PropTypes from 'prop-types';
import withMetrics from '@nib/with-metrics';
import mapMetricsToPropsFactories from './mapMetricsToProps';
var mapMetricsToProps = function mapMetricsToProps(_ref) {
  var pageView = _ref.pageView;
  return {
    pageView: pageView
  };
};
export var findPropsSelectFunc = function findPropsSelectFunc(arg) {
  var found = mapMetricsToPropsFactories.find(function (f) {
    return f(arg);
  });
  if (found) return found(arg);
  return function () {
    throw new Error("Invalid value of type ".concat(_typeof(arg), ". Expecting: object or function"));
  };
};
var trackedPageViewComponentFactory = function trackedPageViewComponentFactory(WrappedPage, getProps) {
  var TrackedPageView = /*#__PURE__*/function (_React$Component) {
    _inherits(TrackedPageView, _React$Component);
    function TrackedPageView() {
      _classCallCheck(this, TrackedPageView);
      return _possibleConstructorReturn(this, (TrackedPageView.__proto__ || Object.getPrototypeOf(TrackedPageView)).apply(this, arguments));
    }
    _createClass(TrackedPageView, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.pageView(getProps(this.props));
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          pageView = _this$props.pageView,
          otherProps = _objectWithoutProperties(_this$props, ["pageView"]); //eslint-disable-line
        return React.createElement(WrappedPage, otherProps);
      }
    }]);
    return TrackedPageView;
  }(React.Component);
  TrackedPageView.propTypes = {
    pageView: PropTypes.func.isRequired
  };
  return TrackedPageView;
};
export { trackedPageViewComponentFactory };
export default function (WrappedPage, props) {
  var propsSelectFunc = findPropsSelectFunc(props);
  var TrackedPage = trackedPageViewComponentFactory(WrappedPage, propsSelectFunc);
  return withMetrics(mapMetricsToProps)(TrackedPage);
}
//# sourceMappingURL=trackedPageFactory.js.map